export const SCAN_TO_ORDER_INFO_TEST_ID = {
  root: 's2o-info-banner',
};
